import { createSelector } from '@reduxjs/toolkit';
import { Share } from '../../model';
import { RootSelector, getStore } from '../../models/rootSelector';
import { SharedLinksShape } from './reducer';

export const getSharedLinks: RootSelector<SharedLinksShape> = createSelector(
  getStore,
  (x) => x.sharedLinks,
);

export const getInProgress: RootSelector<boolean> = createSelector(
  getSharedLinks,
  (x) => x.inProgress,
);

export const getShares: RootSelector<Share[]> = createSelector(getSharedLinks, (x) => x.shares);

export const getExpirationValue: RootSelector<string> = createSelector(
  getSharedLinks,
  (x) => x.expirationValue,
);

export const getExpirationInProgress: RootSelector<boolean> = createSelector(
  getSharedLinks,
  (x) => x.expirationInProgress,
);

export const getSearchQuery = createSelector(getSharedLinks, (x) => x.searchQuery);

export const getSelectedShareIds: RootSelector<string[]> = createSelector(
  getSharedLinks,
  (x) => x.selectedShareIds,
);

export const isExpirationButtonEnabled = createSelector(
  [getSelectedShareIds, getExpirationInProgress, getExpirationValue],
  (selectedShareIds, expirationInProgress, expirationValue) => {
    return (
      selectedShareIds.length === 1 && !expirationInProgress && parseInt(expirationValue, 10) > 0
    );
  },
);

export const isExpirationInputEnabled = createSelector(
  [getSelectedShareIds, getExpirationInProgress],
  (selectedShareIds, expirationInProgress) => {
    return selectedShareIds.length === 1 && !expirationInProgress;
  },
);

export const getSorter = createSelector(getSharedLinks, (sharedLinks) => sharedLinks.sorter);

export const getPagination = createSelector(
  getSharedLinks,
  (sharedLinks) => sharedLinks.pagination,
);
